import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  output,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { NgOptionComponent, NgSelectComponent } from '@ng-select/ng-select';
import { PageResult } from '@core/model/pagination/page-result';
import { CommonModule } from '@angular/common';
import { NgOption } from '@ng-select/ng-select';
import { debounceTime, Subject } from 'rxjs';
import { FormsModule } from '@angular/forms';
import { deepCopy } from '@shared/services/app-util.service';

@Component({
  selector: 'app-select',
  standalone: true,
  imports: [NgSelectComponent, NgOptionComponent, CommonModule, FormsModule],
  templateUrl: './select.component.html',
  styleUrl: './select.component.css',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectComponent),
      multi: true,
    },
  ],
})
export class SelectComponent implements ControlValueAccessor {
  @ViewChild('vs') vs: NgSelectComponent;
  @Output() search = new EventEmitter<string>();
  @Output() scrollEnd = new EventEmitter<any>();
  @Output() clear = new EventEmitter<boolean>();
  @Output() add = new EventEmitter<boolean>();
  @Output() selectionChanged = new EventEmitter<string>();
  @Input() appendToBody:boolean = true;
  @Input() clearSelectedValue:boolean = false;
  @Input() getAllDatainField:boolean = false;
  @Input() isCallPageRefresh:boolean = false;
  @Input() closeOnSelect:boolean = true;

  modelChanged = new Subject<string>();
  public selected;
  searchTerm;

  private _allowAll = false;
  public get allowAll() {
    return this._allowAll;
  }
  @Input() public set allowAll(v: boolean) {
    this._allowAll = v;
  }

  // tslint:disable-next-line: variable-name
  private _label: string | string[] = 'name';
  public get label() {
    return this._label;
  }
  @Input() public set label(v: string | string[]) {
    this._label = v;
  }

  private _isClearAble: boolean  = true;
  public get isClearAble() {
    return this._isClearAble;
  }
  @Input() public set isClearAble(v: boolean) {
    this._isClearAble = v;
  }
private _showRefresh: boolean  = true;
  public get showRefresh() {
    return this._showRefresh;
  }
  @Input() public set showRefresh(v: boolean) {
    this._showRefresh = v;
  }
  private _value: string | string[] = 'id';
  public get value() {
    return this._value;
  }
  @Input() public set value(v: string | string[]) {
    this._value = v;
  }
  private _placeHolder = '';
  public get placeHolder() {
    return this._placeHolder;
  }
  @Input() public set placeHolder(v: string) {
    this._placeHolder = v;
  }

  @Input() public disabled = false;
  @Input() public addNew = false;
  @Input() public multiple = false;
  @Input() initialSelectedValue: string | null = null;  // GUID or initial value
  @Input() public set clearAll(v: boolean) {
    if (v) {
      this.onClear();
    }
  }

  private _pageResult: PageResult<any>;
  public get pageResult(): PageResult<any> {
    return this._pageResult;
  }
  @Input() public set pageResult(v: PageResult<any>) {}

  loading = true;

  dataBuffer = [];
  bufferSize = 5;
  numberOfItemsFromEndBeforeFetchingMore = 2;

  onChanged: any = () => {};
  onTouched: any = () => {};

  constructor() {
    this.modelChanged.pipe(debounceTime(500)).subscribe(() => {
      this.onSearch();
    });
  }
  getLabel(item: any) {
    let value = deepCopy(item);
    if (Array.isArray(this.label)) {
      this.label.forEach((x) => {
        value = value[x];
      });
    } else {
      value = item[this.label];
    }
    return value;
  }
  getValue(item: any) {
    let value = deepCopy(item);
    if (Array.isArray(this.value)) {
      this.value.forEach((x) => {
        value = value[x];
      });
    } else {
      value = item[this.value];
    }

    return value;
  }
  // ngOnChanges(changes: SimpleChanges) {
  //   if (changes.pageResult?.currentValue) {
  //     if (!this._pageResult?.data?.length) {
  //       this._pageResult = changes.pageResult.currentValue;
  //       this.dataBuffer = this._pageResult.data?.length
  //         ? this._pageResult?.data?.slice(0, this.bufferSize)
  //         : [];
  //     } else {
  //       const newPageResult: PageResult<any> = changes.pageResult.currentValue;
  //       if (newPageResult) {
  //         this._pageResult.pageInfo = newPageResult?.pageInfo;
  //         this._pageResult.totalCount = newPageResult?.totalCount;
  //         newPageResult.data.forEach((element) => {
  //           if (!this._pageResult.data.find((x) => x.id === element.id)) {
  //             this._pageResult.data = [...this._pageResult.data];
  //             this._pageResult.data?.push(element);
  //           }
  //         });
  //       }
  //     }
  //     this.loadToBuffer();
  //     this.loading = false;
  //   }
  // }
  ngOnChanges(changes: SimpleChanges) {
    if (changes['pageResult']?.currentValue) {
      if(this.isCallPageRefresh)
      {
        this._pageResult = new PageResult<any>();
      }
      // Handle pagination data updates as before
      if (!this._pageResult?.data?.length) {
        this._pageResult = changes['pageResult'].currentValue;
        this.dataBuffer = this._pageResult.data?.length
          ? this._pageResult?.data?.slice(0, this.bufferSize)
          : [];
      } else {
        const newPageResult: PageResult<any> = changes['pageResult'].currentValue;
        if (newPageResult) {
          if (newPageResult.replaceAll) {
            this._pageResult = new PageResult<any>();
            this._pageResult.data = newPageResult.data ?? [];
            this._pageResult.pageInfo = newPageResult?.pageInfo;
            this._pageResult.totalCount = newPageResult?.totalCount;
            this.dataBuffer = this._pageResult.data?.length
              ? this._pageResult.data.slice(0, this.bufferSize)
              : [];
          } else {
            this._pageResult.pageInfo = newPageResult?.pageInfo;
            this._pageResult.totalCount = newPageResult?.totalCount;
            newPageResult.data.forEach((element) => {
              if (!this._pageResult.data.find((x) => x.id === element.id)) {
                this._pageResult.data = [...this._pageResult.data];
                this._pageResult.data?.push(element);
              }
            });
          }
        }
      }
      this.loadToBuffer();
      this.loading = false;
    }
    // Check for initial selected value and set it if available
    if ( this.initialSelectedValue) {
      
      const selectedItem = this._pageResult?.data?.find(
        (item) => item.id === this.initialSelectedValue
      );
      if (selectedItem) {
        this.selected = selectedItem.id; // Assign the selected item based on GUID
        this.onChanged(this.selected);   // Notify Angular Forms of the change
      }
    }
    else{
      if(this.clearSelectedValue)
        this.selected = null; // Clear the selected value
    //this.onChanged(null); // Notify Angular Forms

    }
  }

  writeValue(obj: any): void {
    try {
      this.selected = obj || null;
      if (this.selected) {
        const selectedItem = this._pageResult?.data?.find(item => item.id === this.selected);
        if (selectedItem) {
          this.selected = selectedItem.id; // Sets the selected item by its GUID
        }
      }
      this.onChanged(this.selected);
    } catch (error) {
      console.error('Error setting selected value:', error);
    }
  }


  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  scrollToEnd() {
    if (this._pageResult) {
      if (this._pageResult?.pageInfo?.hasNextPage) {
        this.loading = true;
        this.scrollEnd.emit(this.dataBuffer?.length);
      }
    }
  }

  scroll({ end }) {
    if (
      this.loading ||
      this._pageResult?.data?.length <= this.dataBuffer.length
    ) {
      return;
    }

    if (
      end + this.numberOfItemsFromEndBeforeFetchingMore >=
      this.dataBuffer.length
    ) {
      this.loadToBuffer();
    }
  }

  private loadToBuffer() {
    this.loading = true;
    const len = this.dataBuffer.length;
    const more = this._pageResult.data?.length
      ? this._pageResult?.data?.slice(len, this.getAllDatainField? this._pageResult.data?.length :this.bufferSize + len)
      : [];
    this.dataBuffer = this.dataBuffer.concat(more);
    this.loading = false;
  }

  onChange() {
    this.modelChanged.next('');
  }

  onSearch(term?: string) {
    // Don't clear pageResult if we're just restoring the same search term
    // This prevents "No items found" flash when restoring search
    const isSameSearch = term === this.searchTerm && this._pageResult?.data?.length > 0;
    
    if (!isSameSearch) {
      this._pageResult = new PageResult<any>();
      this.loading = true;
    }
    
    // Store the search term to preserve it
    this.searchTerm = term || '';
    
    // Only emit search if it's a new search or we don't have data
    if (!isSameSearch) {
      this.search.emit(term);
    }
  }

  onClear() {
    this._pageResult = new PageResult<any>();
    this.loading = true;
    // Clear search term when clearing the dropdown
    this.searchTerm = '';
    if (this._allowAll) {
      this.selected = '';
    }
    this.clear.emit(true);
  }

  registerOnChange(fn: any) {
    this.onChanged = fn;
  }
  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  select(ev) {
    this.onTouched();
    this.onChanged(ev);
    this.selectionChanged.emit(ev);
  }

  blur() {
    this.onTouched();
    if (!this.selected) {
      this.onChanged(null);
      // Only clear search if there's no active search term
      if (!this.searchTerm) {
        this.search.emit('');
      }
    }
    // Don't clear search term for multiple selects - preserve it for better UX
    // The search term will be preserved and can be used when dropdown reopens
    if(this.initialSelectedValue && !this.searchTerm){
      this.search.emit('');
      this.searchTerm = '';
    }
  }

  onAdd() {
    this.vs.close();
    this.add.emit(true);
  }

  public resetSelection(): void {
    this.selected = null;
    this.onChanged(null); // notify Angular Forms
    if (this.vs) {
      this.vs.clearModel(); // NgSelect internal clear
    }
  }

  onOpen() {
    // Restore search term when dropdown opens if it exists
    if (this.searchTerm && this.vs && this.searchTerm.trim()) {
      // Use setTimeout to ensure ng-select is fully initialized
      setTimeout(() => {
        if (this.vs && this.searchTerm) {
          try {
            // Try to set the search term directly on the ng-select component
            // This will restore the search text in the input field
            if (this.vs.searchTerm !== undefined) {
              this.vs.searchTerm = this.searchTerm;
            }
            // Don't re-emit search if we already have data for this search term
            // This prevents clearing existing results when restoring search term
            // The service should already have the search term set from the previous search
          } catch (error) {
            // Silently fail - the search term is already preserved in the service
          }
        }
      }, 0);
    }
  }

  public focus(): void {
    if (this.vs) {
      this.vs.focus();
    }
  }

}
